import { createAsyncThunk } from "@reduxjs/toolkit";

export const createDnsRecord = createAsyncThunk(
    'dns/createDnsRecord',
    async({dnsData})=>{
        try{
        }catch(err){
        }
    }
)